// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3sxSs","column":"style_column__20L11","row":"style_row__3agh1"};